// @flow
import { Modal as DesktopModal } from "antd";
import { Modal } from "antd-mobile";
import React from "react";
import Styled from "styled-components";
interface PopupModalProps {
	open: boolean;
	onClose(): void;
	children: any;
	animationType?: string;
}

const PopupModal =
	(Component) =>
	({ open, onClose, children, animationType }: PopupModalProps) => {
		return (
			<Component
				visible={open}
				transparent
				onClose={onClose}
				animationType={animationType}
				popup
				style={{ zIndex: 9 }}
			>
				{children}
			</Component>
		);
	};

export const PopupModalDesktop = PopupModal(DesktopModal);

export default PopupModal(Modal);
